// function splitHighlight(element) {
//     const words = element.textContent.trim().split(/\s+/);

//     element.innerHTML = words
//         .map(word => `<span class="tmp-word">${word}</span>`)
//         .join(' ');

//     const wordEls = [...element.querySelectorAll('.tmp-word')];

//     const lines = [];
//     let currentTop = null;
//     let currentLine = [];

//     wordEls.forEach(word => {
//         const top = Math.round(word.getBoundingClientRect().top);

//         if (currentTop === null) {
//             currentTop = top;
//         }

//         if (top !== currentTop) {
//             lines.push(currentLine.join(' '));
//             currentLine = [];
//             currentTop = top;
//         }

//         currentLine.push(word.textContent);
//     });

//     if (currentLine.length) {
//         lines.push(currentLine.join(' '));
//     }

//     element.innerHTML = lines
//         .map(line => `<span class="highlight-line">${line}</span>`)
//         .join('');
// }

// document.querySelectorAll('.highlight').forEach(splitHighlight);